import { create } from 'zustand';

interface AnalyticsUIState {
  periodo: string;
  cantidadMeses: number;

  setPeriodo: (value: string) => void;
  setCantidadMeses: (value: number) => void;

  reset: () => void;
}

const initialState = {
  periodo: '',
  cantidadMeses: 6,
};

export const useAnalyticsUIStore = create<AnalyticsUIState>(set => ({
  ...initialState,

  setPeriodo: periodo => set({ periodo }),
  setCantidadMeses: cantidadMeses => set({ cantidadMeses }),

  reset: () => set(initialState),
}));
